import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { BetPerHour } from '../../../Bets/bets';
import { JackPot } from '../../../Bets/jackpot';
import { OtherWinners } from '../../../Bets/others';
import { AverageBet } from '../../../Bets/others copy';
import { BetsPerDay } from '../../../Bets/betsperday';

import { BetsPerDayParner } from '../../../Bets/betsperdaypartner.jsx';

import CSV from '../../../CSV';
import { JackPotCount } from '../../../Bets/jackpotcount';
import { BetsType } from '../../../Bets/betstype';
import { LiveJackPoptWinners } from '../../../Bets/LiveJackPoTWinners';
import { NewlyRecruitedDeposits } from '../../../Reports/newlyrecruitedvsdeposits';
import { WinnerSelect } from '../../../Finance/winnerselect';
import { DrawWinner } from '../../../Finance/drawwinner';
import { DailyDepositTickets } from '../../../Finance/dailydepositstickets';

export default () => (
  <Switch>
    <Route path="/betsperday" component={BetsPerDay} />

    <Route path="/betsperday_h" component={BetsPerDayParner} />

    <Route path="/tickets_t" component={DailyDepositTickets} />

    
    <Route path="/betsperhour" component={BetPerHour} />
    <Route path="/jackpot" component={JackPot} />

    <Route path="/drawwinner" component={DrawWinner} />
    
    <Route path="/winner_select" component={WinnerSelect} />

    
    <Route path="/otherwinners" component={OtherWinners} />
    <Route path="/averagebets" component={AverageBet} />
    <Route path="/reconciledeposits" component={CSV} /> 

         <Route path="/jackpotlive" component={LiveJackPoptWinners}/>

    <Route path="/jackpotcount" component={JackPotCount} />
    <Route path="/betstype" component={BetsType} />

    <Route path="/newlyrecruiteddeposits" component={NewlyRecruitedDeposits} />

    

    {/* <Route/> */}
    </Switch>
);
